import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { CS_REVIEW_PAGE_NAME } from '../../../constants/service/app/csReviewConstants';
import CsReviewListWrap from '../../../views/cs/review/list/CsReviewListWrap';

const CsReviewList = () => {
  return (
    <PageTemplate pageName={CS_REVIEW_PAGE_NAME.REVIEW_LIST}>
      <CsReviewListWrap />
    </PageTemplate>
  );
};

export default CsReviewList;
